import Vue from "vue";
import { Component } from "vue-property-decorator";

const ComponentProps = Vue.extend({
  props: {},
});

@Component<ServiceClinicCardSkeleton>({
  name: "service-clinic-card-skeleton",
})

export default class ServiceClinicCardSkeleton extends ComponentProps {
  
}
